import MODULE_ID from './moduleId';
import routeHandler from './routes';
import constants from './constants';

const module = {
  moduleType: 'VbzWorksheet',
  moduleId: MODULE_ID, // id used for vuex module name
  api: 'worksheet', // module path

  routeHandler,
  /**
   * Lifecycle method called after the user has been authenticated.
   * It is called in lifecyclePhases#initializeSocketIo for every configured module that implements
   * this function.
   * Socket rooms should be subscribed here in case the app needs to receive
   * socket.io events even if the module is not displayed.
   * @param {*} rootState vuex root state
   * @param {*} commit vuex commit object
   * @param {*} socket socket instance (namespaced, but does not matter)
   */
  initModuleSockets: ({ rootState, commit, socket }) => {
    // Join socket room if not done yet
    //if (rootState.vbzWorksheet.hasJoinedSocketRoom === false) {
    console.debug(`initModuleSockets, join-room vbzWorksheet`);
    try {
      // Remark: First version was to initiate room joining by the following code and the respective handler on server side
      // However this is not necessary because the room is joined as soon the client is connected on the server side.
      // socket.emit('join-room', { room: 'vbzWorksheet' }, (response) => {
      //   console.debug(`join-room response: Status=${response.status} Message=${response.msg}`);
      // });

      commit(`${MODULE_ID}/setHasJoinedSocketRoom`, true, { root: true });

      // receiver of event "domain-items" sent by the server to the vbzWorksheet room
      socket.on('domain-items', ({ domain, domainItems }) => {
        console.debug(`Received domain items per socket.io ${domainItems.length} ${domain} items`);
        let now = Date.now();
        const changeDuration = constants.showChangesDurationInSeconds * 1000;
        domainItems.forEach((i) => {
          let createdAt = Date.parse(i.createdAt);
          i.receivedAt = now;
          i.changeType = now - createdAt > changeDuration ? 'geändert' : 'neu';
        });

        commit(`${MODULE_ID}/saveDomainItems`, { domain, items: domainItems }, { root: true });
      });
    } catch (err) {
      console.error('Failed to join-room vbzWorksheet', err);
    }
  },
};

export default module;
